import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const pdsModalFooterCss = "pds-modal-footer{display:block;width:100%}.pds-modal__footer{width:100%}";

const PdsModalFooter$1 = /*@__PURE__*/ proxyCustomElement(class PdsModalFooter extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("footer", { key: 'ea47425a063c04c1cdff3481fc09f32bd65b7679', class: "pds-modal__footer" }, h("slot", { key: '55c560cb8cca95687eb04ba727ae45542ef2209f' })));
    }
    static get style() { return pdsModalFooterCss; }
}, [4, "pds-modal-footer"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-modal-footer"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-modal-footer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsModalFooter$1);
            }
            break;
    } });
}

const PdsModalFooter = PdsModalFooter$1;
const defineCustomElement = defineCustomElement$1;

export { PdsModalFooter, defineCustomElement };
//# sourceMappingURL=pds-modal-footer.js.map

//# sourceMappingURL=pds-modal-footer.js.map